import { Component } from '@angular/core';

@Component({
  selector: 'app-results-zero-facet',
  templateUrl: './results-zero-facet.component.html',
  styleUrls: ['./results-zero-facet.component.css']
})
export class ResultsZeroFacetComponent {

}
